<template>
  <div class="active_table">
    <div class="table" style="padding-top: 50px;">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "提醒标题",
            key: "reminderTitle",
            align: "center",
          },
          {
            title: "基本信息",
            key: "reminderContent",
            align: "center",
          },
          {
            title: "时间范围",
            key: "reminderDate",
            align: "center",
          },
          {
            title: "预设有效期",
            key: "reminderValidityPeriod",
            align: "center",
          },
          {
            title: "提醒状态",
            key: "reminderStatus",
            align: "center",
          },
          // {
          //   title: "邮件通知",
          //   key: "reminderNotified",
          //   align: "center",
          //   render: (h, params) => {
          //     return h("div", [
          //       h(
          //         "span",
          //         {},
          //         this.getWeixin(params.row.reminderNotified) 
          //       ),
          //     ]);
          //   },
          // },
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
    };
  },
  components: {
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteReminderList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          //content: this.search,
        },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // getWeixin(id) {
    //   return id == 1 ? "已通知" : "未通知"
    // },
  },
};
</script>